import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import {
  getCategoryLayoutRoot,
  getCategoryTreePanelSize,
  getCategoryTreeType,
} from '../../../store/selectors/category';
import categoryActions from '../../../store/slices/category';

import Category from './Category';

interface Props {
  id: UniqueId;
  showCommands: boolean;
}

const mapStateToProps = (state: AppState, { id, showCommands }: Props) => ({
  layoutRoot: getCategoryLayoutRoot(state, id),
  id,
  showCommands,
  treePanelSize: getCategoryTreePanelSize(state, id),
  treeType: getCategoryTreeType(state, id),
});

const mapDispatchToProps = {
  onResize: categoryActions.resizeLayout,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  { onResize }: typeof mapDispatchToProps,
  { id, ...oP }: Props
) => ({
  ...sP,
  ...oP,
  onResize: (percent: number) => onResize({ categoryId: id, percent }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type CategoryContainerProps = ConnectedProps<typeof connector>;

export default connector(Category);
